import Table from './Table'

export default Table



// WEBPACK FOOTER //
// ./src/legacy/containers/Tables/Crpcomponents/Table/index.js